import React from 'react';
import style from './SIAD.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SIAD(props) {
  return (
    <div className={style.SIAD}>
      <Head>
        <title>System Integration and Design | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a>E&#178; Engineering Services</a></Link></li>
        <span>/</span>
        <li><Link href={'/e2-engineering-services/electrical-system-design'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> Electrical System Design</a></Link></li>
        <span>/</span>
      </div>
      <h3>System Integration and Design</h3>
      <p>It&#39;s not just about installing a new piece of equipment and setting up the PID Loop, it&#39;s about system integration. Basler Services has experience with all types of generating systems and how to properly interface all of the new and old elements together for a more reliable and efficient system.</p>
      <p>Protect your investment from damage caused by incorrect equipment application due to inexperienced staff, vendors or consultants. Basler Services&#39; expert installers take pride in our attention to detail to ensure your project runs smoothly.</p>
      <p>Basler Services has experience with the following system upgrades:</p>
      <div>
        <ul>
          <li>Excitation/Voltage Regulator</li>
          <li>Protection System</li>
          <li>Synchronizing System</li>
          <li>Gas & Steam Turbine System</li>
          <li>50 Hz to 60 Hz Conversion</li>
          <li>60 Hz to 50 Hz Conversion</li>
        </ul>
      </div>
      <p>Our system design capabilities include:</p>
      <div>
        <ul>
          <li>Small Hydroelectric Planning and Design</li>
          <li>Power System Stabilizer Interface</li>
          <li>AC & DC Emergency Backup Systems</li>
          <li>Plant Relocations</li>
          <li>Operating Plant Improvements</li>
          <li>Switchgear System Planning & Design</li>
          <li>Motor Control Center Design</li>
          <li>Protection Systems Planning and Design</li>
        </ul>
      </div>
      <Link href={"/contact-us"}><a className={`${style.cta} ${style.primaryCta}`}>Contact Us <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
    </div>
  );
}

export default SIAD;